import { render, staticRenderFns } from "./NewDriver.vue?vue&type=template&id=fa31e824&"
import script from "./NewDriver.vue?vue&type=script&lang=ts&"
export * from "./NewDriver.vue?vue&type=script&lang=ts&"
import style0 from "./NewDriver.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports